<template>
  <div class="noScan">
    <img src="../../assets/img/404/404.png">
    <p>
      岳阳地区代理人销售通道还未开放，敬请期待
    </p>
  </div>
</template>

<script>
export default {
  name: 'NoScan',

  components: {},

  filters: {},

  mixins: [],

  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  destroyed() {
  },

  methods: {}
}
</script>

<style scoped lang="scss">
  .noScan {
    width: px2percent(228, 375);
    margin: px2rem(90, 375) auto;
    height: 100vh;
    background-color: #FBFBFB;
    img {
      width: 90%;
    }

    p {
      margin-top: px2rem(34, 375);
      text-align: center;
      font-size: px2rem(16, 375);
      line-height: 1.5;
      color: #999;
    }
  }

</style>
